// Global constants for the application

// Default currency to use when none is provided
export const DEFAULT_CURRENCY = "USD";

// Confidence threshold for extracted values
export const CONFIDENCE_THRESHOLD = 0.8;

// Common currencies
export const CURRENCIES = [
    { code: "USD", symbol: "$", name: "US Dollar" },
    { code: "EUR", symbol: "€", name: "Euro" },
    { code: "GBP", symbol: "£", name: "British Pound" },
    { code: "JPY", symbol: "¥", name: "Japanese Yen" },
    { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
    { code: "AUD", symbol: "A$", name: "Australian Dollar" },
    { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
    { code: "CNY", symbol: "元", name: "Chinese Yuan" },
    { code: "INR", symbol: "₹", name: "Indian Rupee" },
    { code: "RUB", symbol: "₽", name: "Russian Ruble" },
    { code: "KRW", symbol: "₩", name: "South Korean Won" },
    { code: "BRL", symbol: "R$", name: "Brazilian Real" },
    { code: "MXN", symbol: "MX$", name: "Mexican Peso" },
    { code: "ZAR", symbol: "R", name: "South African Rand" },
    { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
    { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
    { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
    { code: "SEK", symbol: "kr", name: "Swedish Krona" },
    { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
    { code: "DKK", symbol: "kr", name: "Danish Krone" },
    { code: "THB", symbol: "฿", name: "Thai Baht" },
    { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
    { code: "PHP", symbol: "₱", name: "Philippine Peso" },
    { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
    { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
    { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
    { code: "TRY", symbol: "₺", name: "Turkish Lira" },
    { code: "PLN", symbol: "zł", name: "Polish Złoty" },
    { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
    { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
];

export const ISO4217_CURRENCIES = [
    { code: "AFN", symbol: "؋", name: "Afghan Afghani" },
    { code: "ALL", symbol: "L", name: "Albanian Lek" },
    { code: "DZD", symbol: "د.ج", name: "Algerian Dinar" },
    { code: "AOA", symbol: "Kz", name: "Angolan Kwanza" },
    { code: "ARS", symbol: "$", name: "Argentine Peso" },
    { code: "AMD", symbol: "֏", name: "Armenian Dram" },
    { code: "AWG", symbol: "ƒ", name: "Aruban Florin" },
    { code: "AUD", symbol: "A$", name: "Australian Dollar" },
    { code: "AZN", symbol: "₼", name: "Azerbaijani Manat" },
    { code: "BSD", symbol: "$", name: "Bahamian Dollar" },
    { code: "BHD", symbol: ".د.ب", name: "Bahraini Dinar" },
    { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
    { code: "BBD", symbol: "$", name: "Barbadian Dollar" },
    { code: "BYN", symbol: "Br", name: "Belarusian Ruble" },
    { code: "BZD", symbol: "BZ$", name: "Belize Dollar" },
    { code: "BMD", symbol: "$", name: "Bermudian Dollar" },
    { code: "BTN", symbol: "Nu.", name: "Bhutanese Ngultrum" },
    { code: "BOB", symbol: "Bs.", name: "Bolivian Boliviano" },
    { code: "BAM", symbol: "KM", name: "Bosnia-Herzegovina Convertible Mark" },
    { code: "BWP", symbol: "P", name: "Botswanan Pula" },
    { code: "BRL", symbol: "R$", name: "Brazilian Real" },
    { code: "GBP", symbol: "£", name: "British Pound" },
    { code: "BND", symbol: "B$", name: "Brunei Dollar" },
    { code: "BGN", symbol: "лв", name: "Bulgarian Lev" },
    { code: "BIF", symbol: "FBu", name: "Burundian Franc" },
    { code: "KHR", symbol: "៛", name: "Cambodian Riel" },
    { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
    { code: "CVE", symbol: "$", name: "Cape Verdean Escudo" },
    { code: "KYD", symbol: "$", name: "Cayman Islands Dollar" },
    { code: "XAF", symbol: "FCFA", name: "Central African CFA Franc" },
    { code: "XPF", symbol: "₣", name: "CFP Franc" },
    { code: "CLP", symbol: "$", name: "Chilean Peso" },
    { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
    { code: "COP", symbol: "$", name: "Colombian Peso" },
    { code: "KMF", symbol: "CF", name: "Comorian Franc" },
    { code: "CDF", symbol: "FC", name: "Congolese Franc" },
    { code: "CRC", symbol: "₡", name: "Costa Rican Colón" },
    { code: "HRK", symbol: "kn", name: "Croatian Kuna" },
    { code: "CUP", symbol: "₱", name: "Cuban Peso" },
    { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
    { code: "DKK", symbol: "kr", name: "Danish Krone" },
    { code: "DJF", symbol: "Fdj", name: "Djiboutian Franc" },
    { code: "DOP", symbol: "RD$", name: "Dominican Peso" },
    { code: "XCD", symbol: "EC$", name: "East Caribbean Dollar" },
    { code: "EGP", symbol: "E£", name: "Egyptian Pound" },
    { code: "ERN", symbol: "Nfk", name: "Eritrean Nakfa" },
    { code: "ETB", symbol: "Br", name: "Ethiopian Birr" },
    { code: "EUR", symbol: "€", name: "Euro" },
    { code: "FKP", symbol: "£", name: "Falkland Islands Pound" },
    { code: "FJD", symbol: "FJ$", name: "Fijian Dollar" },
    { code: "GMD", symbol: "D", name: "Gambian Dalasi" },
    { code: "GEL", symbol: "₾", name: "Georgian Lari" },
    { code: "GHS", symbol: "GH₵", name: "Ghanaian Cedi" },
    { code: "GIP", symbol: "£", name: "Gibraltar Pound" },
    { code: "GTQ", symbol: "Q", name: "Guatemalan Quetzal" },
    { code: "GGP", symbol: "£", name: "Guernsey Pound" },
    { code: "GNF", symbol: "FG", name: "Guinean Franc" },
    { code: "GYD", symbol: "GY$", name: "Guyanaese Dollar" },
    { code: "HTG", symbol: "G", name: "Haitian Gourde" },
    { code: "HNL", symbol: "L", name: "Honduran Lempira" },
    { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
    { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
    { code: "ISK", symbol: "kr", name: "Icelandic Króna" },
    { code: "INR", symbol: "₹", name: "Indian Rupee" },
    { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
    { code: "IRR", symbol: "﷼", name: "Iranian Rial" },
    { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar" },
    { code: "ILS", symbol: "₪", name: "Israeli New Shekel" },
    { code: "JMD", symbol: "J$", name: "Jamaican Dollar" },
    { code: "JPY", symbol: "¥", name: "Japanese Yen" },
    { code: "JEP", symbol: "£", name: "Jersey Pound" },
    { code: "JOD", symbol: "JD", name: "Jordanian Dinar" },
    { code: "KZT", symbol: "₸", name: "Kazakhstani Tenge" },
    { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
    { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar" },
    { code: "KGS", symbol: "с", name: "Kyrgystani Som" },
    { code: "LAK", symbol: "₭", name: "Laotian Kip" },
    { code: "LBP", symbol: "ل.ل", name: "Lebanese Pound" },
    { code: "LSL", symbol: "L", name: "Lesotho Loti" },
    { code: "LRD", symbol: "L$", name: "Liberian Dollar" },
    { code: "LYD", symbol: "ل.د", name: "Libyan Dinar" },
    { code: "MOP", symbol: "MOP$", name: "Macanese Pataca" },
    { code: "MKD", symbol: "ден", name: "Macedonian Denar" },
    { code: "MGA", symbol: "Ar", name: "Malagasy Ariary" },
    { code: "MWK", symbol: "MK", name: "Malawian Kwacha" },
    { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
    { code: "MVR", symbol: "Rf", name: "Maldivian Rufiyaa" },
    { code: "MRU", symbol: "UM", name: "Mauritanian Ouguiya" },
    { code: "MUR", symbol: "₨", name: "Mauritian Rupee" },
    { code: "MXN", symbol: "MX$", name: "Mexican Peso" },
    { code: "MDL", symbol: "L", name: "Moldovan Leu" },
    { code: "MNT", symbol: "₮", name: "Mongolian Tugrik" },
    { code: "MAD", symbol: "د.م.", name: "Moroccan Dirham" },
    { code: "MZN", symbol: "MT", name: "Mozambican Metical" },
    { code: "MMK", symbol: "K", name: "Myanmar Kyat" },
    { code: "NAD", symbol: "N$", name: "Namibian Dollar" },
    { code: "NPR", symbol: "₨", name: "Nepalese Rupee" },
    { code: "ANG", symbol: "ƒ", name: "Netherlands Antillean Guilder" },
    { code: "TWD", symbol: "NT$", name: "New Taiwan Dollar" },
    { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
    { code: "NIO", symbol: "C$", name: "Nicaraguan Córdoba" },
    { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
    { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
    { code: "OMR", symbol: "ر.ع.", name: "Omani Rial" },
    { code: "PKR", symbol: "₨", name: "Pakistani Rupee" },
    { code: "PAB", symbol: "B/.", name: "Panamanian Balboa" },
    { code: "PGK", symbol: "K", name: "Papua New Guinean Kina" },
    { code: "PYG", symbol: "₲", name: "Paraguayan Guarani" },
    { code: "PEN", symbol: "S/", name: "Peruvian Sol" },
    { code: "PHP", symbol: "₱", name: "Philippine Peso" },
    { code: "PLN", symbol: "zł", name: "Polish Złoty" },
    { code: "QAR", symbol: "ر.ق", name: "Qatari Rial" },
    { code: "RON", symbol: "lei", name: "Romanian Leu" },
    { code: "RUB", symbol: "₽", name: "Russian Ruble" },
    { code: "RWF", symbol: "FRw", name: "Rwandan Franc" },
    { code: "SHP", symbol: "£", name: "Saint Helena Pound" },
    { code: "WST", symbol: "WS$", name: "Samoan Tala" },
    { code: "STN", symbol: "Db", name: "São Tomé and Príncipe Dobra" },
    { code: "SAR", symbol: "ر.س", name: "Saudi Riyal" },
    { code: "RSD", symbol: "дин.", name: "Serbian Dinar" },
    { code: "SCR", symbol: "₨", name: "Seychellois Rupee" },
    { code: "SLL", symbol: "Le", name: "Sierra Leonean Leone" },
    { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
    { code: "SBD", symbol: "SI$", name: "Solomon Islands Dollar" },
    { code: "SOS", symbol: "Sh", name: "Somali Shilling" },
    { code: "ZAR", symbol: "R", name: "South African Rand" },
    { code: "KRW", symbol: "₩", name: "South Korean Won" },
    { code: "SSP", symbol: "£", name: "South Sudanese Pound" },
    { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
    { code: "SDG", symbol: "ج.س.", name: "Sudanese Pound" },
    { code: "SRD", symbol: "$", name: "Surinamese Dollar" },
    { code: "SZL", symbol: "E", name: "Swazi Lilangeni" },
    { code: "SEK", symbol: "kr", name: "Swedish Krona" },
    { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
    { code: "SYP", symbol: "£", name: "Syrian Pound" },
    { code: "TJS", symbol: "ЅМ", name: "Tajikistani Somoni" },
    { code: "TZS", symbol: "TSh", name: "Tanzanian Shilling" },
    { code: "THB", symbol: "฿", name: "Thai Baht" },
    { code: "TOP", symbol: "T$", name: "Tongan Paʻanga" },
    { code: "TTD", symbol: "TT$", name: "Trinidad and Tobago Dollar" },
    { code: "TND", symbol: "د.ت", name: "Tunisian Dinar" },
    { code: "TRY", symbol: "₺", name: "Turkish Lira" },
    { code: "TMT", symbol: "m", name: "Turkmenistani Manat" },
    { code: "UGX", symbol: "USh", name: "Ugandan Shilling" },
    { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia" },
    { code: "AED", symbol: "د.إ", name: "United Arab Emirates Dirham" },
    { code: "USD", symbol: "$", name: "US Dollar" },
    { code: "UYU", symbol: "$U", name: "Uruguayan Peso" },
    { code: "UZS", symbol: "лв", name: "Uzbekistan Som" },
    { code: "VUV", symbol: "VT", name: "Vanuatu Vatu" },
    { code: "VES", symbol: "Bs.S", name: "Venezuelan Bolívar Soberano" },
    { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
    { code: "XOF", symbol: "CFA", name: "West African CFA Franc" },
    { code: "YER", symbol: "﷼", name: "Yemeni Rial" },
    { code: "ZMW", symbol: "ZK", name: "Zambian Kwacha" },
    { code: "ZWL", symbol: "Z$", name: "Zimbabwean Dollar" },
];

// Helper functions for handling null values
export const nullToEmpty = (value: string | null | undefined): string => {
    return value === null || value === undefined ? "" : value;
};

export const nullToZero = (value: number | null | undefined): number => {
    return value === null || value === undefined ? 0 : value;
};

// Helper function to safely format date for input
export const formatDateForInput = (dateValue: any): string => {
    if (!dateValue) return "";

    try {
        // Try to parse the date - this could be in various formats
        const date = new Date(dateValue);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            console.warn("Invalid date value:", dateValue);
            return "";
        }

        // Format as YYYY-MM-DD for the input
        return date.toISOString().split("T")[0];
    } catch (error) {
        console.warn("Error formatting date:", error);
        return "";
    }
};
